// .env values are copied from Angular's environment.ts style which uses quotes
// and trailing commas (e.g. value = 'abc',). Strip them so runtime values are clean.
const stripEnvValue = (val: string | undefined): string =>
  (val ?? '').replace(/^['"]/, '').replace(/['"],?$/, '');

export const ENV_CONFIG = {
  php1Url: process.env.REACT_APP_API_apiUrlemis1 ?? '',
  php3Url: process.env.REACT_APP_API_apiUrlemis3 ?? '',
  djangoTnEmisUrl: process.env.REACT_APP_API_apiUrlTnEmisDjango ?? '',
  djangoEmisUrl: process.env.REACT_APP_API_apiUrlEmisDjango ?? '',
  djangoDashboardUrl:
    stripEnvValue(process.env.REACT_APP_API_apiUrlDashboardDjango) ||
    'https://dashboard-webapistage.tnsed.com',
  loginUrl:
    stripEnvValue(process.env.REACT_APP_API_loginApiBaseUrl) ||
    'https://tng2c2.tnschools.gov.in/emis_login/api',
  emis_login: process.env.REACT_APP_API_loginApiBaseUrl ?? '',
  // External portals the top-nav links out to (SLAS / SMC). The header's SLAS
  // and SMC tabs open these URLs instead of switching to an in-app view.
  slasSiteURL: stripEnvValue(process.env.REACT_APP_API_slasSiteURL),
  smcSiteURL: stripEnvValue(process.env.REACT_APP_API_smcSiteURL),
};

export default ENV_CONFIG;
